import { useContext } from "react";
import { AnimationContext } from "./heroAnimationContext";

// Custom Hook for accessing the context
export const useAnimationContext = () => {
  return useContext(AnimationContext);
};
